import { coloringDT } from "./fn_color.js"
// Account

const user_types = {
    premium: {
        name: 'premium',
        color: '#FF5193',
    },
    admin: {
        name: 'admin',
        color: '#000000',
    },
    lifetime: {
        name: 'lifetime',
        color: '#FFBF51',
    },
    trial: {
        name: 'trial',
        color: '#D0E951',
    },
    basic: {
        name: 'basic',
        color: '#536BFF',
    },
    event: {
        name: 'event',
        color: '#D0E951',
    },
}

const service_languages = {
    en: {
        name: 'English',
    },
    ko: {
        name: '한국어',
    },
}

// Projects

const project_mode = {
    0: {
        code: 'tree',
        color: '#BFD833',
    },
    1: {
        code: 'note',
        color: '#FA7268',
    },
}

const project_status = {
    1: {
        name: 'working',
        color: '#F4F5F0',
    },
    2: {
        name: 'complete',
        color: '#F5ECD2',
    },
    3: {
        name: 'holding',
        color: '#EDF1FE',
    },
    4: {
        name: 'preparing',
        color: 'rgba(237, 237, 237, 0.4)',
    },
}

const project_tags = [
    '#FF6672',
    '#FF9628',
    '#66E5D1',
    '#D0E951',
    '#FFBF51',
]

// Issues

const ticket_status = [
    { "id": 0, "name": "new" },
    { "id": 1, "name": "in_progress" },
    { "id": 2, "name": "reporter_action" },
    { "id": 3, "name": "solution_provided" },
    { "id": 9, "name": "closed" },
]

const ticket_types = [
    { "id": 1, "name": "document" },
    { "id": 101, "name": "authentication" },
    { "id": 102, "name": "purchase" },
    { "id": 201, "name": "error" },
    { "id": 255, "name": "etc" },
]

const doc_ticket_types = [
    { id: 1, code: 'document_details', name: 'Document Details' },
    { id: 2, code: 'related_documents', name: 'Related Documents' },
    { id: 3, code: 'references', name: 'References' },
    { id: 4, code: 'other_issue', name: 'Other Issue' },
]

// Payment

const payment_kinds = {
    0: {
        id: 0,
        name: 'paypal',
    },
    1: {
        id: 1,
        name: 'cash',
    },
    2: {
        id: 2,
        name: 'free',
    },
    3: {
        id: 3,
        name: 'payletter',
    },
}

const payment_status = {
    0: {
        id: 0,
        name: 'requested',
    },
    1: {
        id: 1,
        name: 'completed',
    },
    2: {
        id: 2,
        name: 'failed',
    },
    3: {
        id: 3,
        name: 'canceled',
    },
    4: {
        id: 4,
        name: 'refunded',
    },
    5: {
        id: 5,
        name: 'cashwait',
    },
    6: {
        id: 6,
        name: 'card_requested',
    },
    7: {
        id: 7,
        name: 'card_completed',
    },
    8: {
        id: 8,
        name: 'card_failed',
    },
}

// Input documents

const doc_types = {
    0: {
        key: 0,
        keyname: 'book',
        name: 'Book',
        color: coloringDT(0, 1, 1),
        abb: 'B',
        order: 0,
        required_fields: [
            'authors', 'date', 'book_title',
        ],
        compare_columns: [
            'authors', 'book_title', 'lang', 'contents', 'keywords',
            'DOI', 'URL', 'volume', 'edition', 'publisher', 'OCLC', 'ISBN',
            'editors', 'translators', 'paper_ebook',
        ],
    },
    100: {
        key: 100,
        keyname: 'book_chapter',
        name: 'Book Chapter',
        color: coloringDT(100, 1, 1),
        abb: 'BC',
        order: 1,
        required_fields: [
            'authors', 'date', 'chapter_title',
        ],
        compare_columns: [
            'authors', 'chapter_title', 'lang', 'description', 'keywords',
            'DOI_chapter', 'URL_chapter', 'book_title', 'volume', 'pages',
            'edition', 'publisher', 'DOI_book', 'OCLC', 'ISBN', 'URL_book',
            'editors', 'translators', 'publishing_date', 'other_idf', 'paper_ebook',
        ],
    },
    5: {
        key: 5,
        keyname: 'journal',
        name: 'Journal',
        color: coloringDT(5, 1, 1),
        abb: 'J',
        order: 2,
        required_fields: [
            'authors', 'date', 'issue_title',
        ],
        compare_columns: [
            'authors', 'issue_title', 'lang', 'contents', 'URL',
            'journal_name', 'volume', 'institution', 'ISSN', 'editors',
            'paper_online',
        ],
    },
    105: {
        key: 105,
        keyname: 'journal_article',
        name: 'Journal Article',
        color: coloringDT(105, 1, 1),
        abb: 'JA',
        order: 3,
        required_fields: [
            'authors', 'date', 'article_title',
        ],
        compare_columns: [
            'authors', 'article_title', 'journal_name', 'volume', 'pages',
            'DOI_article', 'lang', 'abstract', 'keywords', 'editors',
            'translators', 'institution', 'ISSN', 'URL_article',
            'URL_journal', 'paper_online', 'other_idf',
        ],
    },
    6: {
        key: 6,
        keyname: 'conference',
        name: 'Conference',
        color: coloringDT(6, 1, 1),
        abb: 'C',
        order: 4,
        required_fields: [
            'authors', 'date', 'issue_title',
        ],
        compare_columns: [
            'authors', 'issue_title', 'lang', 'contents', 'DOI', 'URL',
            'conference_name', 'numberth', 'session', 'institution',
            'OCLC', 'ISBN', 'editors', 'place',
        ],
    },
    106: {
        key: 106,
        keyname: 'conference_paper',
        name: 'Conference Paper',
        color: coloringDT(106, 1, 1),
        abb: 'CP',
        order: 5,
        required_fields: [
            'authors', 'address_date', 'article_title',
        ],
        compare_columns: [
            'authors', 'article_title', 'lang', 'abstract', 'keywords',
            'DOI_paper', 'URL_article', 'conference_name', 'numberth',
            'pages', 'session', 'institution', 'DOI_proceeding', 'OCLC',
            'ISBN', 'URL_conference', 'editors', 'translators',
            'conference_dates', 'other_idf', 'place',
        ],
    },
    1: {
        key: 1,
        keyname: 'thesis',
        name: 'Thesis',
        color: coloringDT(1, 1, 1),
        abb: 'T',
        order: 6,
        required_fields: [
            'authors', 'date', 'title',
        ],
        compare_columns: [
            'authors', 'title', 'lang', 'contents', 'keywords', 'DOI', 'URL',
            'diplome_title', 'university', 'OCLC', 'juries', 'translators',
            'department',
        ],
    },
    101: {
        key: 101,
        keyname: 'thesis_chapter',
        name: 'Thesis Chapter',
        color: coloringDT(101, 1, 1),
        abb: 'TC',
        order: 7,
        required_fields: [
            'authors', 'date', 'chapter_title',
        ],
        compare_columns: [
            'authors', 'chapter_title', 'lang', 'description', 'keywords',
            'DOI_chapter', 'URL_chapter', 'title', 'pages', 'diplome_title',
            'university', 'DOI_thesis', 'OCLC', 'URL_thesis', 'juries',
            'publishing_date', 'other_idf', 'department',
        ],
    },
    2: {
        key: 2,
        keyname: 'gov_document',
        name: 'Government Document',
        color: coloringDT(2, 1, 1),
        abb: 'GD',
        order: 8,
        required_fields: [
            'authors', 'date', 'document_title',
        ],
        compare_columns: [
            'authors', 'document_title', 'lang', 'contents', 'keywords',
            'DOI', 'URL', 'number', 'document_category', 'institution',
            'OCLC', 'ISBN', 'editors', 'translators', 'department',
        ],
    },
    102: {
        key: 102,
        keyname: 'gov_document_article',
        name: 'Government Document Article',
        color: coloringDT(102, 1, 1),
        abb: 'GA',
        order: 9,
        required_fields: [
            'authors', 'date', 'article_title',
        ],
        compare_columns: [
            'authors', 'article_title', 'lang', 'description', 'keywords',
            'DOI_article', 'URL_article', 'document_title', 'number',
            'pages', 'document_category', 'institution', 'DOI_document',
            'OCLC', 'ISBN', 'URL_report', 'editors', 'publishing_date',
            'other_idf', 'department',
        ],
    },
    3: {
        key: 3,
        keyname: 'law',
        name: 'Law',
        color: coloringDT(3, 1, 1),
        abb: 'L',
        type: 'sub',
        order: 10,
        required_fields: [
            'authors', 'date', 'law_title',
        ],
        compare_columns: [
            'authors', 'law_title', 'lang', 'contents', 'URL', 'number',
            'version', 'institution', 'OCLC', 'translators', 'law_category',
        ],
    },
    103: {
        key: 103,
        keyname: 'law_article',
        name: 'Law Article',
        color: coloringDT(103, 1, 1),
        abb: 'LA',
        order: 11,
        required_fields: [
            'authors', 'date', 'article_title',
        ],
        compare_columns: [
            'authors', 'article_title', 'lang', 'description', 'URL_article',
            'law_title', 'number', 'article_number', 'version', 'institution',
            'OCLC', 'URL_law', 'other_idf', 'law_category',
        ],
    },
    4: {
        key: 4,
        keyname: 'statistics',
        name: 'Statistics',
        color: coloringDT(4, 1, 1),
        abb: 'S',
        order: 12,
        required_fields: [
            'authors', 'date', 'statistics_title',
        ],
        compare_columns: [
            'authors', 'statistics_title', 'lang', 'description', 'URL',
            'number', 'provisional_confirmed', 'institution', 'OCLC',
            'paper_online',
        ],
    },
    104: {
        key: 104,
        keyname: 'statistics_table',
        name: 'Statistics Table',
        color: coloringDT(104, 1, 1),
        abb: 'ST',
        order: 13,
        required_fields: [
            'authors', 'statistics_date', 'table_title',
        ],
        compare_columns: [
            'authors', 'table_title', 'lang', 'description', 'URL_table',
            'statistics_title', 'number', 'provisional_confirmed',
            'institution', 'OCLC', 'URL_statistics', 'publishing_date',
            'other_idf', 'paper_online',
        ],
    },
    7: {
        key: 7,
        keyname: 'newspaper',
        name: 'Newspaper',
        color: coloringDT(7, 1, 1),
        abb: 'N',
        order: 14,
        required_fields: [
            'authors', 'date', 'article_title',
        ],
        compare_columns: [
            'authors', 'article_title', 'lang', 'description', 'DOI',
            'URL', 'newspaper_name', 'number', 'morning_afternoon',
            'company', 'OCLC', 'ISSN', 'paper_online',
        ],
    },
    107: {
        key: 107,
        keyname: 'newspaper_article',
        name: 'Newspaper Article',
        color: coloringDT(107, 1, 1),
        abb: 'NA',
        order: 15,
        required_fields: [
            'reporters', 'date', 'article_title',
        ],
        compare_columns: [
            'reporters', 'article_title', 'lang', 'description', 'DOI',
            'URL_article', 'newspaper_name', 'number', 'pages',
            'morning_afternoon', 'company', 'OCLC', 'ISSN', 'URL_newspaper',
            'translators', 'other_idf', 'paper_online',
        ],
    },
    8: {
        key: 8,
        keyname: 'magazine',
        name: 'Magazine',
        color: coloringDT(8, 1, 1),
        abb: 'M',
        order: 16,
        required_fields: [
            'authors', 'date', 'issue_title',
        ],
        compare_columns: [
            'authors', 'issue_title', 'lang', 'contents', 'URL', 'magazine_name',
            'number', 'publisher', 'ISBN', 'ISSN', 'editors', 'paper_online',
        ],
    },
    108: {
        key: 108,
        keyname: 'magazine_article',
        name: 'Magazine Article',
        color: coloringDT(108, 1, 1),
        abb: 'MA',
        order: 17,
        required_fields: [
            'authors', 'date', 'article_title',
        ],
        compare_columns: [
            'authors', 'article_title', 'lang', 'description', 'keywords',
            'DOI_article', 'URL_article', 'magazine_name', 'number',
            'pages', 'publisher', 'ISBN', 'ISSN', 'URL_magazine',
            'editors', 'translators', 'other_idf', 'paper_online',
        ],
    },
    9: {
        key: 9,
        keyname: 'music_album',
        name: 'Music Album',
        color: coloringDT(9, 1, 1),
        abb: 'MA',
        order: 18,
        required_fields: [
            'creators', 'date', 'album_name',
        ],
        compare_columns: [
            'creators', 'album_name', 'lang', 'contents', 'URL', 'label',
            'dvd_online',
        ],
    },
    109: {
        key: 109,
        keyname: 'music',
        name: 'Music',
        color: coloringDT(109, 1, 1),
        abb: 'MS',
        order: 19,
        required_fields: [
            'creators', 'date', 'music_title',
        ],
        compare_columns: [
            'creators', 'music_title', 'lang', 'description',
            'URL_music', 'album_name', 'label', 'URL_album', 'other_idf',
            'dvd_online',
        ],
    },
    10: {
        key: 10,
        keyname: 'film',
        name: 'Film',
        color: coloringDT(10, 1, 1),
        abb: 'F',
        order: 20,
        required_fields: [
            'directors', 'date', 'film_title',
        ],
        compare_columns: [
            'directors', 'film_title', 'lang', 'description', 'translators',
            'note',
        ],
    },
    110: {
        key: 110,
        keyname: 'film_episode',
        name: 'Film Episode',
        color: coloringDT(110, 1, 1),
        abb: 'FE',
        order: 21,
        required_fields: [
            'directors', 'date', 'episode_title',
        ],
        compare_columns: [
            'directors', 'episode_title', 'lang', 'description',
            'URL_episode', 'film_title', 'episode_number', 'production',
            'URL_film', 'translators', 'year', 'other_idf', 'note',
        ],
    },
    901: {
        key: 901,
        keyname: 'map',
        name: 'Map',
        color: coloringDT(901, 1, 1),
        abb: 'MP',
        order: 22,
        required_fields: [
            'makers', 'date', 'sub_title',
        ],
        compare_columns: [
            'makers', 'sub_title', 'lang', 'description', 'DOI',
            'URL_map', 'map_title', 'map_size', 'publisher', 'URL_publisher',
            'other_idf', 'paper_digital',
        ],
    },
    999: {
        key: 999,
        keyname: 'etc',
        name: 'Etc',
        color: coloringDT(999, 1, 1),
        abb: 'EC',
        order: 23,
        required_fields: [
            'authors', 'date', 'sub_title',
        ],
        compare_columns: [
            'authors', 'sub_title', 'lang', 'description', 'keywords',
            'DOI', 'URL', 'publication_title', 'number', 'pages',
            'edition', 'publisher', 'DOI_publisher', 'OCLC', 'ISBN',
            'URL_publication', 'editors', 'translators', 'publishing_date',
            'other_idf', 'note'
        ],
    },
}

const people_types = {
    authors: {
        complete: 'author_c',
    },
    creators: {
        complete: 'creator_c',
    },
    editors: {
        complete: 'editor_c',
    },
    juries: {
        complete: 'jury_c',
    },
    translators: {
        complete: 'translator_c',
    },
    directors: {
        complete: 'director_c',
    },
    reporters: {
        complete: 'author_c',
    },
    makers: {
        complete: 'maker_c',
    },
    //for law and law article
    authorities: {
        complete: 'authorities_c'
    }
}

const languages = {
    id: {
        key: 'id',
        name: 'Indonesian',
        iso639_2: 'ind',
        names: ['id', 'ind', 'indonesian', '인도네시아어', 'bahasa Indonesia'],
        type: 'sub',
    },
    ms: {
        key: 'ms',
        name: 'Malay',
        iso639_2: 'may',
        names: ['ms', 'may', 'msa', 'Malay', '말레이시아어', 'Bahasa Melayu'],
        type: 'sub',
    },
    da: {
        key: 'da',
        name: 'Danish',
        iso639_2: 'dan',
        names: ['da', 'dan', 'Danish', '덴마크어', 'dansk'],
        type: 'sub',
    },
    de: {
        key: 'de',
        name: 'German',
        iso639_2: 'deu',
        names: ['de', 'deu', 'German', 'deutsch', '독일어', '독어'],
        type: 'sub',
    },
    en: {
        key: 'en',
        name: 'English',
        iso639_2: 'eng',
        names: ['en', 'eng', 'english', '영어'],
        type: 'main',
    },
    es: {
        key: 'es',
        name: 'Spanish',
        iso639_2: 'spa',
        names: ['es', 'spa', 'Spanish', 'castillian', 'español', '스페인어'],
        type: 'sub',
    },
    fr: {
        key: 'fr',
        name: 'French',
        iso639_2: 'fra',
        names: ['fr', 'fra', 'fre', 'french', 'français', 'langue française', '불어', '프랑스어'],
        type: 'main',
    },
    it: {
        key: 'it',
        name: 'Italian',
        iso639_2: 'ita',
        names: ['it', 'ita', 'italian', 'italiano', '이태리어'],
        type: 'sub',
    },
    nl: {
        key: 'nl',
        name: 'Dutch',
        iso639_2: 'dut',
        names: ['nl', 'dut', 'nld', 'Dutch', 'Flemish', '네덜란드어', 'Nederlands', 'Vlaams'],
        type: 'sub',
    },
    pl: {
        key: 'pl',
        name: 'Polish',
        iso639_2: 'pol',
        names: ['pl', 'pol', 'Polish', '폴란드어', 'polski', 'Język polski'],
        type: 'sub',
    },
    pt: {
        key: 'pt',
        name: 'Portuguese',
        iso639_2: 'por',
        names: ['pt', 'por', 'Portuguese', '포르투갈어', 'português'],
        type: 'sub',
    },
    fi: {
        key: 'fi',
        name: 'Finnish',
        iso639_2: 'fin',
        names: ['fi', 'fin', 'Finnish', '핀란드어', 'suomen kieli', 'Suomi'],
        type: 'sub',
    },
    sv: {
        key: 'sv',
        name: 'Swedish',
        iso639_2: 'swe',
        names: ['sv', 'swe', 'Swedish', '스웨덴어', 'svenska'],
        type: 'sub',
    },
    vi: {
        key: 'vi',
        name: 'Vietnamese',
        iso639_2: 'vie',
        names: ['vi', 'vie', 'Vietnamese', '베트남어', 'Tiếng Việt'],
        type: 'sub',
    },
    tr: {
        key: 'tr',
        name: 'Turkish',
        iso639_2: 'tur',
        names: ['tr', 'tur', 'Turkish', '터키어', 'Türkçe'],
        type: 'sub',
    },
    ru: {
        key: 'ru',
        name: 'Russian',
        iso639_2: 'rus',
        names: ['ru', 'rus', 'russian', 'russe', 'русский', '러시아어', '노어', '露語'],
        type: 'sub',
    },
    ar: {
        key: 'ar',
        name: 'Arabic',
        iso639_2: 'ara',
        names: ['ar', 'ara', 'Arabic', 'العَرَبِيَّة', '아랍어'],
        type: 'sub',
    },
    th: {
        key: 'th',
        name: 'Thai',
        iso639_2: 'tha',
        names: ['th', 'tha', 'Thai', 'ภาษาไทย', '태국어'],
    },
    ko: {
        key: 'ko',
        name: 'Korean',
        iso639_2: 'kor',
        names: ['ko', 'kor', 'korean', '한국어', '韓國語', '조선말', '朝鮮語', '고려말', '한글'],
        type: 'main',
    },
    zh: {
        key: 'zh',
        name: 'Chinese',
        iso639_2: 'zho',
        names: ['zh', 'zho', 'chinese', 'chi', 'zho+14', '中文', '汉语', '漢語', '중국어'],
        type: 'sub',
    },
    ja: {
        key: 'ja',
        name: 'Japanese',
        iso639_2: 'jpn',
        names: ['jp', 'jpn', 'japanese', '日本語', 'にほんご', '일본어'],
        type: 'main',
    },
    xx: {
        key: 'xx',
        name: 'Not Recorded',
        names: ['xx', 'others', 'Etc', 'etc.', '기타'],
        type: 'sub',
    },
}

const titles = ['title', 'book_title', 'article_title', 'document_title', 'law_title',
    'statistics_title', 'issue_title', 'album_name', 'table_title', 'film_title',
    'chapter_title', 'music_title', 'episode_title', 'sub_title'
]

const dates = ['date', 'statistics_date', 'address_date']


// Not tested yet

const sort_opts = {
    0: {
        name: 'Title(ascending)',
    },
    1: {
        name: 'Title(descending)',
    },
    2: {
        name: 'Year(oldest first)',
    },
    3: {
        name: 'Year(newest first)',
    },
    4: {
        name: 'Author(ascending)',
    },
    5: {
        name: 'Author(descending)',
    },
}

const citation_styles = {
    mla: {
        name: 'MLA',
    },
    apa: {
        name: 'APA',
    },
    chicago: {
        name: 'Chicago',
    },
}

const enw_types = {
    "government document": "gov_document",
    "aggregated database": "statistics_table",
    "book": "book",
    "book section": "book_chapter",
    "table": "statistics_table",
    "chart": "statistics",
    "conference paper": "conference_paper",
    "conference proceedings": "conference_paper",
    "edited book": "book",
    "film": "film",
    "journal article": "journal_article",
    "legal rule": "law",
    "regulation": "law",
    "magazine article": "magazine_article",
    "map": "map",
    "music": "music",
    "newspaper article": "newspaper_article",
    "online database": "statistics_table",
    "thesis": "thesis"
}

const ris_types = {
    "AGGR": "statistics_table",
    "BOOK": "book",
    "CHAP": "book_chapter",
    "CHART": "statistics",
    "CONF": "conference_paper",
    "CPAPER": "conference_paper",
    "DATA": "statistics_table",
    "DBASE": "statistics_table",
    "EBOOK": "book",
    "ECHAP": "book_chapter",
    "EDBOOK": "book",
    "EJOUR": "journal_article",
    "GOVDOC": "gov_document",
    "JFULL": "journal",
    "JOUR": "journal_article",
    "LEGAL": "law",
    "MAP": "map",
    "MGZN": "magazine_article",
    "MUSIC": "music",
    "NEWS": "newspaper",
    "THES": "thesis",
    "VIDEO": "film",
}

const bib_types = {
    "@article": "journal_article",
    "@book": "book",
    "@booklet": "etc",
    "@conference": "conference_paper",
    "@inbook": "book_chapter",
    "@incollection": "book_chapter",
    "@inproceedings": "conference_paper",
    "@manual": "etc",
    "@mastersthesis": "thesis",
    "@misc": "etc",
    "@phdthesis": "thesis",
    "@proceedings": "conference",
    "@techreport": "gov_document",
    "@unpublished": "etc",
}

const xlsx_columns = [
    "RIS_TAG",
    "FC",
    "TY",
    "AU",
    "PY",
    "T1",
    "T2",
    "LA",
    "VL",
    "IS",
    "SP",
    "EP",
    "ET",
    "PB",
    "AB",
    "KW",
    "DO",
    "UR",
    "SN",
    "ED",
    "TA",
    "N1"
]

const xlsx_keys = [
    "TY",
    "AU",
    "PY",
    "T1",
    "T2",
    "LA",
    "VL",
    "IS",
    "SP",
    "EP",
    "ET",
    "PB",
    "AB",
    "KW",
    "DO",
    "UR",
    "SN",
    "ED",
    "TA",
    "N1"
]

const xlsx_multiple = [
    "AU",
    "ED",
    "TA"
]

const institutions = [
    "publisher",
    "university",
    "institution",
    "company",
    "label",
    "production"
]

const masterpiece_categories = {
    all: { name: 'All', key: null, code: 'all' },
    // theme: { name: 'Theme', key: 0, code: 'theme' },
    person: { name: 'Person', key: 1, code: 'person' },
    document: { name: 'Document', key: 2, code: 'document' },
}

const required_fields = [
    'date', 'statistics_date', 'address_date', 'title',
    'book_title', 'article_title', 'document_title', 'law_title',
    'statistics_title', 'issue_title', 'album_name', 'table_title',
    'film_title', 'chapter_title', 'music_title', 'episode_title',
    'sub_title', 'makers', 'reporters', 'directors', 'creators', 'authors'
]

const column_names = {
    doc_type: {
        name: "Document Type"
    },
    authors: {
        name: "Authors"
    },
    creators: {
        name: "Creators"
    },
    directors: {
        name: "Directors"
    },
    reporters: {
        name: "Reporters"
    },
    makers: {
        name: "Makers"
    },
    author_c: {
        name: "et al."
    },
    creator_c: {
        name: "et al."
    },
    director_c: {
        name: "et al."
    },
    maker_c: {
        name: "et al."
    },
    date: {
        name: "Date"
    },
    statistics_date: {
        name: "Statistics Date"
    },
    address_date: {
        name: "Address Date"
    },
    book_title: {
        name: "Book Title"
    },
    title: {
        name: "Title"
    },
    document_title: {
        name: "Document Title"
    },
    law_title: {
        name: "Law Title"
    },
    statistics_title: {
        name: "Statistics Title"
    },
    issue_title: {
        name: "Issue Title"
    },
    album_name: {
        name: "Album Name"
    },
    film_title: {
        name: "Film Title"
    },
    chapter_title: {
        name: "Chapter Title"
    },
    article_title: {
        name: "Article Title"
    },
    table_title: {
        name: "Table Title"
    },
    music_title: {
        name: "Music Title"
    },
    episode_title: {
        name: "Episode Title"
    },
    sub_title: {
        name: "Title"
    },
    lang: {
        name: "Language"
    },
    contents: {
        name: "Contents"
    },
    description: {
        name: "Description"
    },
    abstract: {
        name: "Abstract"
    },
    keywords: {
        name: "Keywords"
    },
    DOI: {
        name: "DOI"
    },
    DOI_chapter: {
        name: "Chapter DOI"
    },
    DOI_paper: {
        name: "Paper DOI"
    },
    DOI_article: {
        name: "Article DOI"
    },
    URL: {
        name: "URL"
    },
    URL_chapter: {
        name: "Chapter URL"
    },
    URL_article: {
        name: "URL"
    },
    URL_table: {
        name: "Table URL"
    },
    URL_music: {
        name: "Music URL"
    },
    URL_episode: {
        name: "Episode URL"
    },
    URL_map: {
        name: "Map URL"
    },
    journal_name: {
        name: "Journal"
    },
    conference_name: {
        name: "Conference Name"
    },
    newspaper_name: {
        name: "Newspaper Name"
    },
    magazine_name: {
        name: "Magazine Name"
    },
    newspaper_name: {
        name: "Newspaper Name"
    },
    magazine_name: {
        name: "Magazine Name"
    },
    album_name: {
        name: "Album Name"
    },
    film_title: {
        name: "Film Title"
    },
    map_title: {
        name: "Map Title"
    },
    publication_title: {
        name: "Publication Title"
    },
    number: {
        name: "Number"
    },
    numberth: {
        name: "Numberth"
    },
    volume: {
        name: "Volume(Issue)"
    },
    pages: {
        name: "Pages"
    },
    article_number: {
        name: "Article Number"
    },
    episode_number: {
        name: "Episode Number"
    },
    edition: {
        name: "Edition"
    },
    document_category: {
        name: "Document Category"
    },
    version: {
        name: "Version"
    },
    provisional_confirmed: {
        name: "Provisional Confirmed"
    },
    session: {
        name: "Session"
    },
    morning_afternoon: {
        name: "Morning or Afternoon"
    },
    diplome_title: {
        name: "Diplome Type"
    },
    map_size: {
        name: "Map Size"
    },
    publisher: {
        name: "Publisher"
    },
    university: {
        name: "University"
    },
    institution: {
        name: "Publisher"
    },
    company: {
        name: "Company"
    },
    label: {
        name: "Label"
    },
    production: {
        name: "Production"
    },
    DOI_book: {
        name: "Book DOI"
    },
    DOI_thesis: {
        name: "Thesis DOI"
    },
    DOI_document: {
        name: "Document DOI"
    },
    DOI_proceeding: {
        name: "Proceeding DOI"
    },
    DOI_publication: {
        name: "Publication DOI"
    },
    OCLC: {
        name: "OCLC"
    },
    ISBN: {
        name: "ISBN"
    },
    ISSN: {
        name: "ISSN"
    },
    URL_book: {
        name: "Book URL"
    },
    URL_thesis: {
        name: "Thesis URL"
    },
    URL_report: {
        name: "Report URL"
    },
    URL_law: {
        name: "Law URL"
    },
    URL_statistics: {
        name: "Statistics URL"
    },
    URL_journal: {
        name: "Journal URL"
    },
    URL_conference: {
        name: "Conference URL"
    },
    URL_newspaper: {
        name: "Newspaper URL"
    },
    URL_magazine: {
        name: "Magazine URL"
    },
    URL_album: {
        name: "Album URL"
    },
    URL_film: {
        name: "Film URL"
    },
    URL_publication: {
        name: "Publication URL"
    },
    editors: {
        name: "Editors"
    },
    juries: {
        name: "Juries"
    },
    editor_c: {
        name: "et al."
    },
    jury_c: {
        name: "et al."
    },
    translators: {
        name: "Translators"
    },
    translator_c: {
        name: "et al."
    },
    publishing_date: {
        name: "Publishing Date"
    },
    conference_dates: {
        name: "Conference Dates"
    },
    year: {
        name: "Year"
    },
    paper_ebook: {
        name: "E-book"
    },
    department: {
        name: "Department"
    },
    law_category: {
        name: "Law Category"
    },
    paper_online: {
        name: "Online Paper"
    },
    place: {
        name: "Place"
    },
    dvd_online: {
        name: "Online DVD"
    },
    note: {
        name: "Note"
    },
    other_idf: {
        name: "Other Identifiers"
    },
    paper_digital: {
        name: "Digital Paper"
    },
}

export {
    user_types,
    service_languages,

    project_mode,
    project_status,
    project_tags,

    ticket_status,
    ticket_types,
    doc_ticket_types,

    payment_kinds,
    payment_status,

    doc_types,
    people_types,
    languages,
    titles,
    dates,

    sort_opts,
    citation_styles,

    enw_types,
    ris_types,
    bib_types,
    xlsx_columns,
    xlsx_keys,
    xlsx_multiple,
    institutions,
    masterpiece_categories,
    required_fields,
    column_names,
}


// WEBPACK FOOTER //
// ./src/custom/model.js